import React from "react";
import { Button } from "@jem-open/jem-ui";
import { ChevronRight } from "lucide-react";

type BreadcrumbItem = { label: string; onClick?: () => void };

type MultimessagingBreadcrumbProps = {
  items: BreadcrumbItem[];
};

const MultimessagingBreadcrumb: React.FC<MultimessagingBreadcrumbProps> = ({ items }) => (
  <div className="flex items-center gap-xxs text-sm text-greyscale-text-caption mb-md">
    {items.map((item, idx) => {
      const isLast = idx === items.length - 1;
      return (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={idx}>
          {idx !== 0 && <ChevronRight size={14} />}
          {isLast ? (
            <span className="text-greyscale-text-title font-semibold">{item.label}</span>
          ) : (
            <Button
              variant="link"
              className="hover:text-greyscale-text-title p-0 h-auto"
              onClick={item.onClick}
            >
              {item.label}
            </Button>
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default MultimessagingBreadcrumb;
